module.exports = __webpack_public_path__ + "img/en.1bba726e.svg";